<div class="qr-code" lang="{{language()}}">
  @if (artifacts().length) {
    @for (artifact of artifacts(); track artifact) {
      <div class="qr-code__item">
        <qrcode
          class="qr-code__code"
          [elementType]="'svg'"
          [errorCorrectionLevel]="'M'"
          [margin]="0"
          [qrdata]="artifact.artifact_id.split('-').slice(1).join('-')"
        />

        <div class="qr-code__label-container">
          <span class="qr-code__label">
            {{ artifact.object_type === 'package' ? artifact.artifact_name : artifact.identifier }}
          </span>

          @for (data of displayExtraData(); track $index) {
            <span class="qr-code__extra-data">
              {{ data.value }}
            </span>
          }
        </div>
      </div>
    }
  }
</div>
